import React from 'react'
import { postActusParams } from '../../types'
import SlideContent from './SlideContent'
import { ReactComponent as Arrow } from '../../assets/sliderArrow.svg'
import style from './style.module.scss'

interface SlideProps {
    post: postActusParams
    handleSwipe: (next: number) => void
}

export const Slide: React.FC<SlideProps> = ({ post, handleSwipe }) => {
    return (
        <div className={style.slide}>
            <div className={style.left}>
                <SlideContent post={post} />
            </div>

            <div className={style.right}>
                <div className={style.navigation}>
                    <div className={style.prev} onClick={() => handleSwipe(1)}>
                        <Arrow />
                    </div>

                    <div className={style.next} onClick={() => handleSwipe(-1)}>
                        <Arrow />
                    </div>
                </div>

                {post?.thumbnail?.tag && (
                    <picture dangerouslySetInnerHTML={{ __html: post?.thumbnail?.tag }} />
                )}
            </div>
        </div>
    )
}
